<template>
  <div id="tongzhixiangqing">
    <van-sticky>
      <van-nav-bar left-text="返回"
                   left-arrow
                   @click-left="onClickLeft" />
    </van-sticky>
    <div class="main">
      <div class="title">
        <h1>{{title}}</h1>
      </div>
      <div class="subtitle clearfix">
        <span class="time">{{time}}</span>
        <span class="organization">{{organization}}</span>
      </div>
      <div class="unit">{{BM0101}}</div>
      <van-divider :style="{ color: '#dddddd', borderColor: '#dddddd' }"></van-divider>
      <div class="article">
        <article>
          <p v-html="content" style="word-break:break-all;">
           {{content}}
          </p>
        </article>
      </div>
      <div  v-show="attachments.length>0" style="font-size: 0.3rem; margin-top: 0.5rem;">附件：</div>
      <div class="attachment" v-for="(item,i) in attachments" :key="i"
           @click="previewPDFClick(item,item.suffix)">
        <span>{{i+1}}、</span>
        <img src="@/assets/PDF.png"
             alt="PDF"
             width="15" />
        <span>{{item.name}}</span>
      </div>
      <div  v-show="images.length>0" style="font-size: 0.3rem; margin-top: 0.5rem;">图片：</div>
      <div class="clearfix">
        <div class="picture"
             v-for="(img,index) in images"
             :key="index"
             @click="picClick(index)">
          <img :src="img"
               alt />
        </div>
      </div>
    </div>
    <van-image-preview v-model="showPic"
                       :images="images"
                       @change="onChange"
                       :startPosition="startPosition">
      <template v-slot:index>{{indexPic+'/'+images.length}}<br/><br/><br/><br/>
                    {{imgNames[indexPic-1]}}</template>
    </van-image-preview>
    <!-- <div class="PDFShow"
         v-if="pdfshow">
      <pdf ref="pdf"
           :src="pdfUrl"
           style="width: 100%;" />
    </div> -->
    <previewPDF v-if="pdfParams.showPdf" :params="pdfParams" @getpdfShow="getpdfShow"></previewPDF>
  </div>
</template>
<script>
import { Toast } from "vant";
import previewPDF from "@/components/previewPDF/index";
import config from '@/config/index'
import axios from "axios";
// import pdf from 'vue-pdf'
import { loading } from '../../../common/loading'
import{
    tzReadActionAjax
}from  '@/api/baseMsg';
export default {
  name: 'tongzhixiangqing',
  data() {
    return {
      id: this.$route.query.id,
      isPlain: this.$route.query.isPlain,
      title: '',
      time: '',
      organization: '',
      BM0101: '',
      content:'',//正文
      attachments: [
        // {
        //   name: '通知.pdf',
        // },
      ],
      showPic: false,
    //   pdfshow: false,
      indexPic: 0,
      imgNames: [],
      startPosition: 0,
      images: [
        // 'https://img01.yzcdn.cn/vant/apple-1.jpg',
        // 'https://img01.yzcdn.cn/vant/apple-2.jpg',
      ],

      pdfParams:{
          showPdf: false,
          data: ''
      },
    //   pdfUrl: '',
    }
  },
  components:{previewPDF},
  created() {
      loading(true)
      this.readActionAjax();
  },
  mounted() {},
  destroyed() {},
  methods: {
    
    onClickLeft() {
      //返回
    //   this.$router.go(-1)
    this.$router.push({
        path: '/tongzhigonggao/tongzhigonggao',
        query: {
            isPlain:this.isPlain
        }
    })
    },
    onChange(index) {
      //切换图片时回调函数
      this.indexPic = index + 1
    },
    picClick(index) {
      //点击图片
      this.indexPic = index + 1
      this.startPosition = index
      this.showPic = true
    },
    // pdfClick(name) {
    //     // const path = config.baseURL +filePath;
    //     // const path="D:\\侯层层.pdf";
    //     // this.pdfUrl = pdf.createLoadingTask(filePath)
    //     // this.pdfUrl =config.baseURL+"/rdpublicservice/pdfShow/web/viewer.jsp?pdfName="+name;
    //     // this.pdfshow = true
    //     this.pdfParams.showPdf = true;
    // },
    //通知公告详情
    readActionAjax() {
      var getTimestamp = new Date().getTime() //时间戳
      tzReadActionAjax(getTimestamp, {
        id: this.id,
      }).then((result) => {
          let res = result.data
          this.title = res.title;
          this.content = res.content;
          this.time = res.issueTime;
          this.organization = res.CreateName;
          this.BM0101 = res.BM0101
          if(res.suffix != undefined){
              let suffix = res.suffix.replace("\"","").replace("[","").replace("]","").split(",");//后缀
            //   let suffix=res.suffix.split(",");//后缀
              for(let i=0; i<suffix.length; i++){
                  let name = res.Name.replace("\"","").replace("[","").replace("]","").split(",");//名字
                  let relativePath = res.relativePath.replace("\"","").replace("[","").replace("]","").split(",");//路径
                  let fileId = res.fileId.replace("\"","").replace("[","").replace("]","").split(",");//地址
                //   let relativePdfPath=res.relativePdfPath.replace("\"","").replace("[","").replace("]","").split(",");//路径
                  if(this.isImage(suffix[i].trim())){
                    relativePath[i] = relativePath[i].replace('D:/resources', '/xj-images').replace(/\//g, '/')
                     this.images.push(
                        config.baseURL + relativePath[i].trim()
                      )
                       this.imgNames.push(
                          name[i]
                      )
                  }else {
                      this.attachments.push(
                          {
                             name:name[i],
                            //  path:config.baseURL+relativePath[i].trim()
                            path:relativePath[i].trim(),
                            // relativePdfPath:relativePdfPath,
                            suffix:suffix[i].trim(),
                            fileId: fileId[i].trim()
                          }
                      )
                  }
                }
          }
        //   console.log(JSON.parse(JSON.stringify(this.images)))
        //   console.log(JSON.parse(JSON.stringify(this.imgNames)))
        //   console.log(JSON.parse(JSON.stringify(this.attachments)))
        //   ///////
        // //   this.images==[],this.imgNames==[],this.attachments==[];
        //   this.images=JSON.parse(JSON.stringify(this.images));
        //   this.imgNames=JSON.parse(JSON.stringify(this.imgNames));
        //   this.attachments=JSON.parse(JSON.stringify(this.attachments));
        //   console.log(this.images)
        //   console.log(this.imgNames)
        //   console.log(this.attachments)
        loading(false);
        this.images=this.isToArry(this.images);
        this.imgNames=this.isToArry(this.images);
        this.imattachmentsages=this.isToArry(this.images);
        // console.log(this.images)
        // console.log(this.imgNames)
        // console.log(this.attachments)
      })
    },
    isToArry(arr){
        let newArray = JSON.parse(JSON.stringify(arr));
        return newArray;
    },
    isImage(ext) {
        return ['png', 'jpg', 'jpeg', 'bmp', 'gif'].indexOf(ext.toLowerCase()) !== -1;
    },
    isPdf(ext) {
        return ['doc', 'docx', 'xls', 'xlsx'].indexOf(ext.toLowerCase()) !== -1;
    },
    getpdfShow(data) {
        this.pdfParams.showPdf = data;
    },
    previewPDFClick(item,suffix) {
      let path = item.path
      path = path.replace('D:/resources', '/xj-images').replace(/\//g, '/')
      console.log(item)
      // console.log(suffix)
        // path = '/xj-images/datePath/20250514/1d9725c4f5164be8a679ef7642d3a6b5.pdf'
      if(suffix.trim()=='pdf'){//pdf文件打开预览
          this.pdfParams.showPdf = true;
          loading(true)
          axios({
              url: config.devProxy +
              `/zdcommon/fileUpload/download?fileId=${item.fileId}`, //接口地址
              method: "get",
              responseType: "blob",
            }).then((res) => {
              const blob = new Blob([res.data])
              this.pdfParams.data = '/pdfjs/web/viewer.html?file=' + window.URL.createObjectURL(blob)
              loading(false)
              this.pdfParams.showPdf = true
          }).catch((res)=> {
            loading(false)
            Toast.fail("文件出错!")
            return
          })
          // this.pdfParams.data = "/pdfjs/web/viewer.html?file="+ config.baseURL + path
          // alert(this.pdfParams.data)
      }
      // else if(this.isPdf(suffix.trim())){
      //     this.pdfParams.showPdf = true;
      //     this.pdfParams.data = config.baseURL+"/pdfjs/web/viewer.html?file="+path.split(".")[0]+".pdf"
      // }
      else{// 非pdf文件下载
          // window.location.href = config.baseURL + path;
          this.exportDownLoad({
            url: '/zdcommon/fileUpload/download',
            fileId: item.fileId
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#tongzhixiangqing {
  height: 100%;
  /deep/.van-nav-bar__text:active {
    background-color: transparent;
  }
  .main {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    .title {
      margin-top: 0.5rem;
      text-align: center;
      h1 {
        font-size: 0.45rem;
      }
    }
    .subtitle {
      margin-top: 0.25rem;
      .time {
        float: left;
        font-size: px2rem(30);
        color: #3e3e3e;
      }
      .organization {
        float: right;
        font-size: px2rem(30);
        color: #3e3e3e;
      }
    }
    .unit {
      width: 100%;
      text-align: right;
      font-size: px2rem(30);
      color: #3e3e3e;
      margin-bottom: 0.5rem;
    }

    .article {
      margin-top: 0.5rem;
      font-size: 0.3rem;
      p {
        text-indent: 2em;
      }
    }

    .attachment {
      margin-left: 0.2rem;
      font-size: 0.3rem;
    }
    .picture {
      float: left;
      margin-left: 0.2rem;
      width: 2rem;
      height: 3rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .clearfix:before,
    .clearfix:after {
      content: '';
      display: table;
    }
    .clearfix:after {
      clear: both;
    }
    .clearfix {
      *zoom: 1;
    }
  }
}
</style>